import React from 'react';
import useOnClickOutside from '../../../hooks/use-on-click-outside.hook';
import { useEffect, useRef, useState } from 'react';
import { PlayCircleRegularWhiteIcon } from '../icons/icons';
import styles from './video.module.scss';

export interface IVideoRatio {
  height: number;
  width: number;
}

export type Props = {
  src: string;
  videoRatio?: IVideoRatio;
  poster?: string;
  id?: string;
  videoPreload?: boolean;
};

export default function Video({ src, poster, id, videoPreload = true }: Props) {
  const [isVideoPlaying, setIsVideoPlaying] = useState<boolean>(false);

  const ref = useRef<HTMLVideoElement>();

  function play() {
    ref.current.play();
  }

  function pause() {
    ref.current.pause();
  }

  useOnClickOutside(ref, pause);

  useEffect(() => {
    if (ref && ref.current) {
      ref.current.onplaying = () => {
        setIsVideoPlaying(true);
      };
      ref.current.onpause = () => {
        setIsVideoPlaying(false);
      };
      ref.current.onended = () => {
        setIsVideoPlaying(false);
      };
    }
  }, []);

  return (
    <div data-component='video' className={styles['video-wrapper']}>
      {!isVideoPlaying && (
        <button type='button' onClick={play} aria-label='play video' className={styles['play-btn']}>
          <PlayCircleRegularWhiteIcon />
        </button>
      )}

      <video
        className={styles.video}
        controls
        preload={videoPreload ? null : 'none'}
        poster={poster}
        ref={ref}
        disablePictureInPicture
        controlsList='nodownload noplaybackrate'
        id={id}
      >
        <source src={src} />
      </video>
    </div>
  );
}
